import { render, staticRenderFns } from "./TenantActivityCard.vue?vue&type=template&id=231c9cda&scoped=true"
import script from "./TenantActivityCard.vue?vue&type=script&lang=js"
export * from "./TenantActivityCard.vue?vue&type=script&lang=js"
import style0 from "./TenantActivityCard.vue?vue&type=style&index=0&id=231c9cda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231c9cda",
  null
  
)

export default component.exports